import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ConnectionsPage } from '@/features/connections';
// By its path, not the package (its index says why).
import { MembersOnly } from '@/features/workspaces/components/MembersOnly';

// `?create` opens the connection form (spec 128: the setup checklist's link).
const connectionsSearchSchema = z.object({
  create: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute(
  '/workspaces/$workspaceId/integrations/connections',
)({
  validateSearch: connectionsSearchSchema,
  component: ConnectionsRoute,
});

export function ConnectionsRoute() {
  const { workspaceId } = Route.useParams();
  const { create } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MembersOnly what="Connections" workspaceId={workspaceId}>
      <ConnectionsPage
        workspaceId={workspaceId}
        createRequested={create === true}
        onCreateDismissed={() => {
          void navigate({ search: {}, replace: true });
        }}
      />
    </MembersOnly>
  );
}
